"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetPublicDataRawQuery = exports.useGetPublicDataObjectQuery = exports.useGetAppManifestQuery = exports.publicDataApi = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
exports.publicDataApi = (0, react_1.createApi)({
    reducerPath: 'publicDataApi',
    baseQuery: (0, react_1.fetchBaseQuery)({ baseUrl: '/platform' }),
    endpoints: (builder) => ({
        getAppManifest: builder.query({
            query: (arg) => {
                var _a;
                return ({
                    url: `/public-data/${(_a = arg === null || arg === void 0 ? void 0 : arg.appName) !== null && _a !== void 0 ? _a : window.appName}/app-manifest`,
                });
            },
        }),
        getPublicDataObject: builder.query({
            query: ({ appName, key }) => ({
                url: `/public-data/${appName !== null && appName !== void 0 ? appName : window.appName}/${key}`,
            }),
        }),
        getPublicDataRaw: builder.query({
            query: ({ appName, key }) => ({
                url: `/public-data/${appName !== null && appName !== void 0 ? appName : window.appName}/${key}`,
                responseHandler: 'text',
            }),
        }),
    }),
});
exports.useGetAppManifestQuery = exports.publicDataApi.useGetAppManifestQuery, exports.useGetPublicDataObjectQuery = exports.publicDataApi.useGetPublicDataObjectQuery, exports.useGetPublicDataRawQuery = exports.publicDataApi.useGetPublicDataRawQuery;
